import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import { EuiButton, EuiSpacer } from '@elastic/eui';
import RouterCards from 'components/Internet_Access/Port_Forwarding/RouterCards';
import NavButtons from 'components/Internet_Access/NavButtons';
import ForumBox from 'components/Internet_Access/Port_Forwarding/PrimaryBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Port Weiterleitung",
  "path": "/Fernzugriff/Port_Weiterleitung/",
  "dateChanged": "2017-11-27",
  "author": "Mike Polinowski",
  "excerpt": "Um über die DDNS Adress auf Ihre Kamera zu gelangen, müssen Sie zuerst in Ihrem Internet Router einen Port auf die Kamera durchleiten...",
  "image": "./IA_SearchThumb_Portforwarding.png",
  "social": "/images/Search/IA_SearchThumb_Portforwarding.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_IA-Port-Forwarding_white.webp",
  "chapter": "Remote Access"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Portweiterleitung Anleitung – INSTAR Wiki' dateChanged='2017-11-27' author='Mike Polinowski' tag='INSTAR IP Camera' description='Stellen Sie über das Internet eine Verbindung zu Ihrer IP Kamera her. Wir zeigen Beispiele von häufig verwendeten Routern einschließlich AVM Fritzbox, Telekom Speedport, D-Link, Netgear, TP-Link usw.' image='/images/Search/IA_SearchThumb_Portforwarding.png' twitter='/images/Search/IA_SearchThumb_Portforwarding.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Internet_Access/Port_Forwarding/' locationFR='/fr/Internet_Access/Port_Forwarding/' crumbLabel="Port Forwarding" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <h1 {...{
      "id": "port-weiterleitung",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#port-weiterleitung",
        "aria-label": "port weiterleitung permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Port Weiterleitung`}</h1>
    <h2 {...{
      "id": "stellen-sie-über-das-internet-eine-verbindung-zu-ihrer-kamera-her",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#stellen-sie-%C3%BCber-das-internet-eine-verbindung-zu-ihrer-kamera-her",
        "aria-label": "stellen sie über das internet eine verbindung zu ihrer kamera her permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Stellen Sie über das Internet eine Verbindung zu Ihrer Kamera her`}</h2>
    <p>{`Die Schritte zur Portweiterleitung sind bei jedem Router fast die gleichen. Im Folgenden zeigen wir Beispiele von häufig verwendeten Router-Herstellern. Für die Konfiguration Ihrer Kamera lesen Sie bitte zuerst den `}<a parentName="p" {...{
        "href": "/de/Fernzugriff/Der_DDNS_Dienst/"
      }}>{`Schritt I`}</a>{`. Im Folgenden beschreiben wir die benötigte Router Konfiguration für den DDNS Fernzugriff auf Ihre Kamera.`}</p>
    <br />
    <p>{`Kein Audio in der App bei Ihrer 1080p Kamera? `}<Link to="/Software/Mobile_Access_Over_HTTPS/" mdxType="Link"><button className="btn btnRed float-right">{`HTTPS & Audio`}</button></Link></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "712px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/12fa914590cda748f17ab6ed03c39afb/3d4b6/Portforwarding-Fritzbox-7390de_01.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.52173913043479%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABUUlEQVQoz4VS226DMBTr/3/apD1N07ZKDYTcuORCIBRoHzwlKoxuK30wJwJhO/Y58KLB50cGcpL4+qRw5oyuneHdlOYPJvg43fzr/T0OmZpBWQtGK1SlX8kiWjvCu/E2p5vI9I/YhtDYGZxbkJOAFPb24YKmbkGpAC8kSK7wSmYEv4jtOOzbGYJpZERCbQgVKyHyApxLlDogDFf0fiHbcRgf0RnNS1g9oPcX9P6KujSwjUXnR7wcA4wZ0K/ZPiEspUNB6wTThJQZZwpVpSG5hSgUmtomsSXLR0iEGVHIsxJKOsTWdd2jUhZGdwjdNTmOMeyVsclwQptWZUo/h+6yXmlpOsEtTY87mHAgcgahFoyW6cpSmLvVSeRug2cOtT5DN0PKzughFROX+xFiOVqHhHg26znAmiFm+Fd1L3RjA5iowGUD4wYwUePt/QiSCzh3xjd8xkT5Bhq4/gAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/12fa914590cda748f17ab6ed03c39afb/e4706/Portforwarding-Fritzbox-7390de_01.avif 230w", "/de/static/12fa914590cda748f17ab6ed03c39afb/d1af7/Portforwarding-Fritzbox-7390de_01.avif 460w", "/de/static/12fa914590cda748f17ab6ed03c39afb/4fb90/Portforwarding-Fritzbox-7390de_01.avif 712w"],
              "sizes": "(max-width: 712px) 100vw, 712px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/12fa914590cda748f17ab6ed03c39afb/a0b58/Portforwarding-Fritzbox-7390de_01.webp 230w", "/de/static/12fa914590cda748f17ab6ed03c39afb/bc10c/Portforwarding-Fritzbox-7390de_01.webp 460w", "/de/static/12fa914590cda748f17ab6ed03c39afb/c4538/Portforwarding-Fritzbox-7390de_01.webp 712w"],
              "sizes": "(max-width: 712px) 100vw, 712px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/12fa914590cda748f17ab6ed03c39afb/81c8e/Portforwarding-Fritzbox-7390de_01.png 230w", "/de/static/12fa914590cda748f17ab6ed03c39afb/08a84/Portforwarding-Fritzbox-7390de_01.png 460w", "/de/static/12fa914590cda748f17ab6ed03c39afb/3d4b6/Portforwarding-Fritzbox-7390de_01.png 712w"],
              "sizes": "(max-width: 712px) 100vw, 712px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/12fa914590cda748f17ab6ed03c39afb/3d4b6/Portforwarding-Fritzbox-7390de_01.png",
              "alt": "Portforwarding AVM Fritzbox",
              "title": "Portforwarding AVM Fritzbox",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <ul>
      <li parentName="ul">{`siehe auch:`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "%22/Web_User_Interface/1440p_Serie/Netzwerk/IP_Konfiguration/#ipv6-port-weiterleitung%22"
        }}>{`IPv6 Port Weiterleitung (für UHD Kameramodelle`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Schnell_Installation/Internet_Protocol_IPv6/"
        }}>{`Was ist IPv6 und wie funktioniert SLAAC?`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Frequently_Asked_Question/WQHD_IPv6_Portforwarding/"
        }}>{`Anleitung zur IPv6 Portfreischaltung in einer AVM Fritzbox`}</a></li>
    </ul>
    <h3 {...{
      "id": "ii-portweiterleitung-im-router",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#ii-portweiterleitung-im-router",
        "aria-label": "ii portweiterleitung im router permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`II. Portweiterleitung im Router`}</h3>
    <p>{`In diesem Schritt wird in Ihrem Router eingestellt, wie er die Kamera aus Ihrem lokalen Netzwerk in das Internet weiterzuleiten hat. Dieser Schritt wird komplett im Einstellungsmenü Ihres Routers ausgeführt, dementsprechend wählen Sie im Folgenden Ihren Router aus. Beachten Sie, dass Sie diesen Schritt für jede einzelne Ihrer Kameras ausführen müssen.`}</p>
    <br /><br />
    <Link to="/Fernzugriff/Port_Weiterleitung/Router_Zugriff/" mdxType="Link"><button className="btn float-right">Router Access</button></Link>
    <h4 {...{
      "id": "portweiterleitung",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#portweiterleitung",
        "aria-label": "portweiterleitung permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Portweiterleitung`}</h4>
    <p>{`Die Schritte zum Weiterleiten eines Ports an Ihre Kamera sind in jedem Router fast identisch. Im Folgenden zeigen wir Beispiele für die gängigsten Router.`}</p>
    <RouterCards mdxType="RouterCards" />
    <h3 {...{
      "id": "schritt-iii--kamera-adresse-auslesen-und-fernzugriff-auf-die-kamera",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#schritt-iii--kamera-adresse-auslesen-und-fernzugriff-auf-die-kamera",
        "aria-label": "schritt iii  kamera adresse auslesen und fernzugriff auf die kamera permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Schritt III : Kamera-Adresse auslesen und Fernzugriff auf die Kamera`}</h3>
    <Link to="/Fernzugriff/Mobil_Zugriff/" mdxType="Link"><EuiButton fill mdxType="EuiButton">Schritt III</EuiButton></Link>
    <EuiSpacer mdxType="EuiSpacer" />
    <ForumBox mdxType="ForumBox" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      